import { h, Component } from 'preact';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import HeaderFocus from './hubNavigationFocus.js';

import ShareIcons from 'components/editor/hubNavigation/shareIcons/shareIcons';

import s from 'components/editor/hubNavigation/hubNavigation.sss';

export default class Header extends Component {
	constructor(props) {
		super(props);
		this.renderLink = this.renderLink.bind(this);
	}

	renderLink(link) {
		return <span class={joinClasses(s.navItem, link.sublinks && s.expandable)}>{link.name}</span>;
	}

	render() {
		const isFocus = Store.get().domains.isFocus;
		if (isFocus) {
			return <HeaderFocus />;
		}
		const links = Store.get().data?.navigation?.header?.links || [];
		return (
			<header class={s.wrapper} inert>
				<div class={s.main}>
					<button class={s.burger} />
					<img src={`${__IMAGE_ROOT__}/logo.svg`} width="79" height="40" alt="Universal Pictures" />
				</div>
				<modal class={s.drawer}>
					<nav class={s.nav}>
						{links.map(this.renderLink)}
					</nav>
					<ShareIcons class={s.share} />
				</modal>
			</header>
		);
	}
}